<div class="current-user">
  <div class="welcome-card">
    <div class="welcome-glow"></div>
    <img class="welcome-logo" src="/assets/display-website/img/logo.svg" alt="SEVE-TP" />
    <p class="welcome-message">{{ 'welcome_message' | translate: { firstName: user?.userFirstName, lastName: user?.userName } }}</p>
    <span class="welcome-rule"></span>
    <p class="welcome-hint">{{ 'welcome_subtitle' | translate }}</p>
  </div>
</div>
